<script lang="ts">
    type BreadcrumbsItem = {
        title: string;
        url?: string;
    };
    export let list: BreadcrumbsItem[] = [];
</script>

{#if list.length > 0}
    <nav class="overflow-hidden whitespace-nowrap">
        <ul class="inline-flex items-center space-x-1 md:space-x-2" itemscope itemtype="http://schema.org/BreadcrumbList">
            <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
                <a itemprop="item" href="/" class="inline-flex items-center text-sm font-medium text-black-600 hover:text-green">
                    <span itemprop="name">Главная</span>
                    <meta content="0" itemprop="position" />
                </a>
            </li>

            {#each list as item, index}
                {#if index + 1 === list.length}
                    <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
                        <div class="flex items-center gap-1 md:gap-2" itemprop="item">
                            <svg
                                class="w-3 h-3 mx-1 text-black-500"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 6 10"
                            >
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 9 4-4-4-4"
                                />
                            </svg>
                            <span class="text-sm font-medium text-gray-500">
                                <span itemprop="name">{item.title}</span>
                                <meta content={'' + (index + 1)} itemprop="position" />
                            </span>
                        </div>
                    </li>
                {:else}
                    <li class="hidden md:block" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
                        <div class="flex items-center gap-1 md:gap-2">
                            <svg
                                class="w-3 h-3 mx-1 text-gray-400"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 6 10"
                            >
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 9 4-4-4-4"
                                />
                            </svg>
                            <a itemprop="item" href={item.url} class="text-sm font-medium text-black-600 hover:text-green">
                                <span itemprop="name">{item.title}</span>
                                <meta content={'' + (index + 1)} itemprop="position" />
                            </a>
                        </div>
                    </li>
                {/if}
            {/each}
        </ul>
    </nav>
{/if}
